import { useCallback } from "react";

import BoardDropdownItemView from "./BoardDropdownItemView";

import { UserKanbanBoardRole } from "@/generated/graphql";

/**
 * Props for BoardDropdownItem container component
 */
interface BoardDropdownItemContainerProps {
  /** Board identifier */
  readonly boardId: string;
  /** Display name of the board */
  readonly name: string;
  /** Whether this board is currently active/selected */
  readonly isActive: boolean;
  /** User's role on this board */
  readonly userRole?: UserKanbanBoardRole | null;
  /** Callback when a board is selected */
  readonly onBoardSelect: (boardId: string) => void;
}

/**
 * Container component for individual board dropdown item
 * Handles press logic and passes presentation props to view
 * @param root0 - Component props
 * @param root0.boardId - Board identifier
 * @param root0.name - Display name of the board
 * @param root0.isActive - Whether this board is currently active/selected
 * @param root0.userRole - User's role on this board
 * @param root0.onBoardSelect - Callback when a board is selected
 */
const BoardDropdownItemContainer = ({
  boardId,
  name,
  isActive,
  userRole,
  onBoardSelect,
}: BoardDropdownItemContainerProps) => {
  const handlePress = useCallback(() => {
    onBoardSelect(boardId);
  }, [onBoardSelect, boardId]);

  return (
    <BoardDropdownItemView
      name={name}
      isActive={isActive}
      userRole={userRole}
      onPress={handlePress}
    />
  );
};

export default BoardDropdownItemContainer;
